import { AbstractControl, ValidationErrors, UntypedFormGroup, ValidatorFn, UntypedFormArray, Validators } from '@angular/forms';
import * as MOMENT from 'moment';
import { countries,states,cities } from "@app/config/countries_states_citiesList";
import { timeZoneList } from "@app/config/time_zone_config";

// tslint:disable-next-line: only-arrow-functions
export const stringValidation = function (control: AbstractControl): ValidationErrors | null {

  // tslint:disable-next-line: prefer-const
  let value: string = control.value || '';
  return stringValidationForAutoComplete(value, false);
};
export const autoCompleteStringValidation = function (control: AbstractControl): ValidationErrors | null {

  // tslint:disable-next-line: prefer-const
  let value: string = control.value || '';
  return stringValidationForAutoComplete(value, true);
};
// tslint:disable-next-line: only-arrow-functions
export const emailValidation = function (control: AbstractControl): ValidationErrors | null {

  // tslint:disable-next-line: prefer-const
  let value: string = control.value || '';

  if (value) {
    const matches = value.match(/^([A-Za-z0-9_+\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,12})$/);
    // tslint:disable-next-line: object-literal-key-quotes
    return matches ? null : { error: 'Invalid email address.' };
  } else {
    return null;
  }
};

export const numbersOnly = function (control: AbstractControl): ValidationErrors | null {
  const regex = /^\d+$/;
  // tslint:disable-next-line: prefer-const
  let value: string = control.value || '';

  if (value) {
    return (!regex.test(value)) ? { error: 'Invalid. It should have only numbers' } : null;
  } else {
    return null;
  }
}

// tslint:disable-next-line: only-arrow-functions
export const urlValidation = function (control: AbstractControl): ValidationErrors | null {

  // tslint:disable-next-line: prefer-const
  let value: string = control.value || '';

  if (value) {
    if (/^\S*$/.test(value)) {
      // tslint:disable-next-line: prefer-const
      // tslint:disable-next-line: max-line-length
      // const pattern = new RegExp('^(http[s]?:\\/\\/(www\\.)?|ftp:\\/\\/(www\\.)?|(www\\.)?){1}([0-9A-Za-z-\\.@:%_\+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?');
      var pattern = new RegExp("^(http[s]?:\\/\\/(www\\.)?|ftp:\\/\\/(www\\.)?|(www\\.)?){1}([0-9A-Za-z-\\.@:%_\+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?");
      // const pattern = new RegExp(/^http/);
      return (!pattern.test(value) || !/^http[s]?:\/\//.test(value)) ? { error: 'Invalid url format.' } : null;
    } else {
      return { error: 'Spaces are not allowed.' };
    }
  } else {
    return null;
  }
};


// rss validation
export const rssValidation = function (control: AbstractControl): ValidationErrors | null {

  // tslint:disable-next-line: prefer-const
  let value: string = control.value || '';

  if (value) {
    console.log(value, 'rss error')
    // if (/^\S*$/.test(value)) {
    //     // tslint:disable-next-line: prefer-const
    //     // tslint:disable-next-line: max-line-length
    //     // const pattern = new RegExp('^(http[s]?:\\/\\/(www\\.)?|ftp:\\/\\/(www\\.)?|(www\\.)?){1}([0-9A-Za-z-\\.@:%_\+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?');
    //     var pattern = new RegExp("^(http[s]?:\\/\\/(www\\.)?|ftp:\\/\\/(www\\.)?|(www\\.)?){1}([0-9A-Za-z-\\.@:%_\+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?");
    //     // const pattern = new RegExp(/^http/);
    //     return (!pattern.test(value) || !/^http[s]?:\/\//.test(value)) ? { error: 'Invalid url format.' } : null;
    // } else {
    //     return { error: 'Spaces are not allowed.' };
    // }
  } else {
    return null;
  }
};

// tslint:disable-next-line: only-arrow-functions
export const phoneNumber = function (control: AbstractControl): ValidationErrors | null {
  const regex = /^[\+0-9]{0,19}$/;
  // const regex = /^\+[\-\+0-9]{0,19}$/;
  // tslint:disable-next-line: prefer-const
  let value: string = control.value || '';

  if (value) {
    return (!regex.test(value)) ? { error: 'Invalid phone number.' } : null;
  } else {
    return null;
  }
};


export const companyMatch = (firstMatch: string, secondMatch: string,firstName:string = null): ValidatorFn => {
  return (form: UntypedFormGroup): { [key: string]: any } | null => {
    if (form.get(firstMatch).value && form.get(secondMatch).value) {
      if (( form.get(firstMatch).value == form.get(secondMatch).value ) || (firstName === form.get('spin_off_company_name').value)) {
        form.get(secondMatch).setErrors({ error: 'Above Company Name should not be same.' })
        return;
      } else {
        form.get(secondMatch).setErrors(null);
        return;
      }
    }
  };
}

export const checkDuplicateId = (arrayName: string, firstId: string, secondId: string,firstName = '',secondName = ''): ValidatorFn => {
  return (form: UntypedFormGroup): { [key: string]: any } | null => {
    let mergeCompnines = form.get(arrayName) as UntypedFormArray;
    let allIds = [];
    let allMergerCompanys = [];
    form['value'][arrayName].forEach((element: any, index: number) => {
      const allCompanys = form['value'][arrayName];
      let ids = allCompanys.map(item => item[firstId]);
      let companys = allCompanys.map(item => item[firstName]);
      allIds = [...ids];
      allMergerCompanys = [...companys];
      ids.splice(index, 1);
      companys.splice(index, 1);
      if ( (mergeCompnines.at(index)['value'][firstId] && ids.includes(mergeCompnines.at(index)['value'][firstId])) || (mergeCompnines.at(index)['value'][firstName] && companys.includes(mergeCompnines.at(index)['value'][firstName]))) {
        mergeCompnines.at(index).get(firstId).setErrors({ error: 'Duplicate Company name' })
      } else if ((mergeCompnines.at(index)['value'][firstId] && !ids.includes(mergeCompnines.at(index)['value'][firstId])) || (mergeCompnines.at(index)['value'][firstName] && !companys.includes(mergeCompnines.at(index)['value'][firstName]))) {
        mergeCompnines.at(index).get(firstId).setErrors(null);
      }
    });
    let allCompanysId = form['value'][arrayName].map(item => item[firstId]);
    // console.log(allCompanysId);
   let allCompanyNames = form['value'][arrayName].map(item => item[firstName]);
    if ( (form.get(secondId).value && allCompanysId.includes(form.get(secondId).value)) || (form.get(secondName).value && allCompanyNames.includes(form.get(secondName).value))) {
      form.get(secondId).setErrors({ error: 'Duplicate Company name' })
    } else if ( (form.get(secondId).value && !allCompanysId.includes(form.get(secondId).value)) || (form.get(secondName).value && !allCompanyNames.includes(form.get(secondName).value))) {
      form.get(secondId).setErrors(null);
    }
    return null
  };
}
export const checkTickerValidation = (ticker: string,exchange:string,primaryTicker: string): ValidatorFn => {
  return (form: UntypedFormGroup): { [key: string]: any } | null => {
    let allTickers = form.get('securities') as UntypedFormArray;
    if (form['value'] && form['value']['securities']) {
      form['value']['securities'].forEach((element: any, index: number) => {
        const allSecurities = form['value']['securities'];
        let values = allTickers.at(index)['value'];
        if (values[ticker] && values[exchange] && findDuplicate(allSecurities, ticker, exchange)['isInValid']) {
          allTickers.at(index).get(exchange).setErrors({ error: 'Above Ticker and exchange should not be same.' })
        } else if (values[ticker] && values[exchange] && !findDuplicate(allSecurities, ticker, exchange)['isInValid']) {
          allTickers.at(index).get(exchange).setErrors(null)
        }

        if ((values[primaryTicker] === true || values[primaryTicker] === false) && checkPrimaryTickerCount(allSecurities)) {
          allTickers.at(index).get(primaryTicker).setErrors({ error: 'Only one  primary ticker allowed.' });
        } else if ((values[primaryTicker] === true || values[primaryTicker] === false) && !checkPrimaryTickerCount(allSecurities)) {
          allTickers.at(index).get(primaryTicker).setErrors(null);
        }
      })
      return null
    }
  };
}

export const validateValidDates = (firstMatch: string, secondMatch: string, lessthanAction = false): ValidatorFn => {
  return (form: UntypedFormGroup): { [key: string]: any } | null => {
    if (form.get(firstMatch).value && form.get(secondMatch).value && MOMENT(form.get(firstMatch).value, 'YYYY-MM-DD', true).isValid() && MOMENT(form.get(secondMatch).value, 'YYYY-MM-DD', true).isValid()) { 
      if (!MOMENT(form.get(secondMatch).value).isAfter(form.get(firstMatch).value))  {
        if(!lessthanAction)
          form.get(secondMatch).setErrors({ error: `${secondMatch} should be greater than ${firstMatch}` })
        else
          form.get(firstMatch).setErrors({ error: `${firstMatch} should be less than ${secondMatch}` })
        return;
      } else {
        if(!lessthanAction)
          form.get(secondMatch).setErrors(null)
        else
          form.get(firstMatch).setErrors(null)
        return;
      }
     }
  };
}
export const checkConferenceDates = (firstMatch: string, secondMatch: string): ValidatorFn => {
  return (form: UntypedFormGroup): { [key: string]: any } | null => {
    if (form.get(firstMatch).value && form.get(secondMatch).value && MOMENT(form.get(firstMatch).value, 'YYYY-MM-DD', true).isValid() && MOMENT(form.get(secondMatch).value, 'YYYY-MM-DD', true).isValid()) { 
      if (!MOMENT(form.get(secondMatch).value).isAfter(form.get(firstMatch).value) && MOMENT(form.get(firstMatch).value).format('YYYY-MM-DD') !== MOMENT(form.get(secondMatch).value).format('YYYY-MM-DD') )  {
        form.get(secondMatch).setErrors({ error: `${secondMatch} should be greater than or equal to ${firstMatch}` })
        return;
      } else {
        form.get(secondMatch).setErrors(null)
        return;
      }
     }
  };
}

export const CheckGuidanceValidations = (key1: string = '', key2: string = '', key3: string = '', key4: string = '', key5: string = ''): ValidatorFn => {
  return (form: UntypedFormGroup): { [key: string]: any } | null => {
    // if( )  {
      let text = '';
      if(key5 && form.get(key5)) {
        text = form.get(key5).value
      }
      if(form.get(key1).value || form.get(key2).value || form.get(key3).value || form.get(key4).value ||  (key5 && form.get(key5) && form.get(key5).value)) {
        if(!form.get(key1).value) form.get(key1).setErrors({ error: 'This field is required' });
        if(!form.get(key2).value) form.get(key2).setErrors({ error: 'This field is required' });
        if(!form.get(key3).value) form.get(key3).setErrors({ error: 'This field is required' });
        if(!form.get(key4).value) form.get(key4).setErrors({ error: 'This field is required' });
        if(key5 && form.get(key5) && !form.get(key5).value) form.get(key5).setErrors({ error: 'This field is required' });
      } else if((!form.get(key1).value && (!form.get(key2).value && form.get(key2).value !== 0) && (!form.get(key3).value && form.get(key3).value !== 0) && !form.get(key4).value && !text)){
        form.get(key1).setErrors(null);
        form.get(key2).setErrors(null);
        form.get(key3).setErrors(null);
        form.get(key4).setErrors(null);
        if( key5 && form.get(key5)) { 
          form.get(key5).setErrors(null);
        } 
        return
      }
    // }
  };
}

export const rangeValidation = function (control: AbstractControl): ValidationErrors | null {
  const regex = /^\d{1,2}(\.\d{1,2})?$/
  // const regex2 = /^[123456789]{1,2}$/;
  // const regex = /^\d+\.\d{0,2}$/;
  // const regex = /^\+[\-\+0-9]{0,19}$/;
  let value: any = control.value;
  if (value || value === 0) {
    if( value === 0 ) {
      return { error: 'Please enter valid number' };
    } else if( value !== 0 && !regex.test(value)) {
      return { error: 'Please enter valid number' };
    }
  } else {
    return null;
  }
};

export const checkConferenceErrors = (): ValidatorFn => {
  return (form: UntypedFormGroup): { [key: string]: any } | null => {
    if ((!form.get('live_webcast_url').value && (!form.get('live_phone_us').value && !form.get('live_passcode_us').value)) ||
      (!form.get('live_webcast_url').value && (!form.get('live_phone_us').value && form.get('live_passcode_us').value)) ||
      (!form.get('live_webcast_url').value && (form.get('live_phone_us').value && !form.get('live_passcode_us').value))) {
      if (!form.get('live_webcast_url').value)
        form.get('live_webcast_url').setErrors({ error: 'This field is required' });
      if (!form.get('live_phone_us').value)
        form.get('live_phone_us').setErrors({ error: 'This field is required' });
      if (!form.get('live_passcode_us').value)
        form.get('live_passcode_us').setErrors({ error: 'This field is required' });
      return;
    } else {
      if ((form.get('live_webcast_url').value && form.get('live_webcast_url').valid) || (form.get('live_phone_us').value && form.get('live_phone_us').valid && form.get('live_passcode_us').value && form.get('live_passcode_us').valid)) {
        form.get('live_phone_us').setErrors(null)
        form.get('live_passcode_us').setErrors(null)
        form.get('live_webcast_url').setErrors(null)

        form.get('live_phone_us').setValidators([phoneNumberWithCountryCode])
        form.get('live_passcode_us').setValidators([passCode])
        form.get('live_webcast_url').setValidators([urlValidation])

        form.get('live_phone_us').updateValueAndValidity({onlySelf : true,emitEvent:false})
        form.get('live_passcode_us').updateValueAndValidity({onlySelf : true,emitEvent:false})
        form.get('live_webcast_url').updateValueAndValidity({onlySelf : true,emitEvent:false})
        return;
      }
    }
  };
}

export const validateManulFilesForm = (): ValidatorFn => {
  return (form: UntypedFormGroup): { [key: string]: any } | null => {
    if(!form.get('file').value  && !form.get('url').value ) {
      form.get('url').setValidators([Validators.required, urlValidation])
      form.get('file').setValidators([Validators.required])
      form.get('file').updateValueAndValidity({onlySelf : true,emitEvent:false})
      form.get('url').updateValueAndValidity({onlySelf : true,emitEvent:false})
    } else if(form.get('file').valid || form.get('url').valid) {
      form.get('url').setValidators([urlValidation])
      form.get('file').setValidators([])
      form.get('file').updateValueAndValidity({onlySelf : true,emitEvent:false})
      form.get('url').updateValueAndValidity({onlySelf : true,emitEvent:false})
    }
    return;
  }
}

export const priceValidation = function (control: AbstractControl): ValidationErrors | null {
  const regex = /^[0-9!@#\$%\^\&*\)\(+=._-]+$/g;
  // const regex = /^\+[\-\+0-9]{0,19}$/;
  // tslint:disable-next-line: prefer-const
  let value: string = control.value || '';

  if (value) {
    return (!regex.test(value)) ? { error: 'Alphabets and space not allowed not allowed' } : null;
  } else {
    return null;
  }
};


export const splitValidation = function (control: AbstractControl): ValidationErrors | null {
  const regex = /^([0-9]+):([0-9]+)$/;
  // const regex = /^\+[\-\+0-9]{0,19}$/;
  // tslint:disable-next-line: prefer-const
  let value: string = control.value || '';

  if (value) {
    return (!regex.test(value)) ? { error: 'Invalid Split Ratio' } : null;
  } else {
    return null;
  }
};

export const yearValidation = function (control: AbstractControl): ValidationErrors | null {
  const regex = /^(19|20)\d{2}$/;
  // const regex = /^\+[\-\+0-9]{0,19}$/;
  // tslint:disable-next-line: prefer-const
  let value: string = control.value || '';

  if (value) {
    return (!regex.test(value)) ? { error: 'Invalid Year' } : null;
  } else {
    return null;
  }
};


export const fileExtentions = function (control: AbstractControl): ValidationErrors | null {
  let value: string = control.value || '';

  if (value) {
    var ext = value.substring(value.lastIndexOf('.') + 1);
    return (ext.toLowerCase() !== 'pdf') ? { error: 'Invalid format' } : null;
  } else {
    return null;
  }
};


export const passCode = function (control: AbstractControl): ValidationErrors | null {
  // const regex = /^[\*\#A-Za-z0-9]+$/
  // const regex = /^[\#A-Za-z0-9]+$/
  // tslint:disable-next-line: prefer-const
  let value: string = control.value || '';
  if (value) {
    return (value.match(/[/\s!@$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/)) ? { error: 'Invalid passcode, Passcode could be a mix of number and alphabets and  "#" symbol.' } : null;
  } else {
    return null;
  }
};

// tslint:disable-next-line: only-arrow-functions
export const tickerValidation = function (control: AbstractControl): ValidationErrors | null {
  // tslint:disable-next-line: prefer-const
  let value: string = control.value || '';
  if (value) {
    if (value && !value.match(/^[^\s]+(\s+[^\s]+)*$/)) {
      return { error: 'Should not begin or end with space.' };
    } else if (value && !(/^[a-zA-Z\d\-\/_.$+*#@%^=&\s]+$/.test(value))) {
      return { error:  "Invalid ticker. Ticker should not contain special characters other than '-, _, ., /, @, #, $, %, ^, &, *, +, =, ' '."};
    } else {
      return null;
    }
  } else {
    return null;
  }
};

// tslint:disable-next-line: only-arrow-functions
export const dateValidation = function (control: AbstractControl): ValidationErrors | null {
  // tslint:disable-next-line: prefer-const
  let value: string = control.value || '';
  const errorMessage = 'Invalid format, Date should be in YYYY-MM-DD.';
  return dateValidationService(value, false, new RegExp(/^\d\d\d\d-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])$/), errorMessage, 'YYYY-MM-DD');
};

// tslint:disable-next-line: only-arrow-functions
export const enddateValidation = function (control: AbstractControl): ValidationErrors | null {
  // tslint:disable-next-line: prefer-const
  let value: string = control.value || '';
  const errorMessage = 'Invalid format, Date should be in YYYY-MM-DD or N/A.';
  return dateValidationService(value, true, new RegExp(/^\d\d\d\d-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])$/), errorMessage, 'YYYY-MM-DD');
};

// tslint:disable-next-line: only-arrow-functions
export const utcDateTimeValidation = function (control: AbstractControl): ValidationErrors | null {
  // tslint:disable-next-line: prefer-const
  let value: string = control.value || '';
  const errorMessage = 'Invalid format, datetime should be in YYYY-MM-DDTHH:MM:SSZ format.';
  const pattren = new RegExp(/^\b[0-9]{4}-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])T(0[0-9]|1[0-9]|2[0-3]):(0[0-9]|[0-5][0-9]):(0[0-9]|[0-5][0-9])Z\b$/);
  return dateValidationService(value, false, pattren, errorMessage, 'YYYY-MM-DDTHH:mm:ssZ');
  // if (value) {
  //     if (!value.match(/^[^\s]+(\s+[^\s]+)*$/)) {
  //     return { spacesNotAllowed: true };
  //     // tslint:disable-next-line: max-line-length
  //     } else if (!(/^\b[0-9]{4}-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])T(0[0-9]|1[0-9]|2[0-3]):(0[0-9]|[0-5][0-9]):(0[0-9]|[0-5][0-9])Z\b$/).test(value)) {
  //     return { error: 'Invalid format, datetime should be in YYYY-MM-DDTHH:MM:SSZ format.' };
  //     } else {
  //     const utc = MOMENT(value, 'YYYY-MM-DDTHH:mm:ssZ', true);
  //     return (!utc.isValid()) ?  {  error: 'Invalid UTC date and time.' } : null;
  //     }
  // } else {
  //     return null;
  // }
};
// tslint:disable-next-line: only-arrow-functions
export const slugValidation = function (control: AbstractControl): ValidationErrors | null {
  // tslint:disable-next-line: prefer-const
  let value: string = control.value || '';
  if (value) {
    return (!(/^[A-Za-z0-9]+(?:-[A-Za-z0-9]+)*$/).test(value)) ? { error: 'Invalid slug format.' } : null;
  } else {
    return null;
  }
};

const dateValidationService = (value: any, bool: boolean, pattren: any, errMsg: string, format: string) => {
  if (value) {
    if (value !== 'N/A') {
      value = MOMENT(value).format(format)
    }
    if (!value.match(/^[^\s]+(\s+[^\s]+)*$/)) {
      return { spacesNotAllowed: true };
      // tslint:disable-next-line: max-line-length
    } else if (!(pattren).test(value)) {
      if (bool) {
        if (value !== 'N/A') {
          return { error: errMsg };
        } else {
          return null;
        }
      } else {
        return { error: errMsg };
      }
    } else {
      const utc = MOMENT(value, format, true);
      if (MOMENT(value).format('YYYY') == '0000') return { error: 'Invalid date' }
      return (!utc.isValid()) ? { error: 'Invalid date' } : null;
    }
  } else {
    return null;
  }
}

export const timeValidations = function (control: AbstractControl): ValidationErrors | null {
  // tslint:disable-next-line: prefer-const
  let value: string = control.value || '';
  if (value) {
    return null;
    // return (!(/^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/gm).test(value)) ? {  error: 'Time should be in HH:MM:SS format.'} : null;
    // return (!(/^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$/gm).test(value)) ? {  error: 'Time should be in HH:MM:SS format.'} : null;
  } else {
    return null;
  }
};

const stringValidationForAutoComplete = (value: any, boolean: boolean) => {
  if (value) {
    // console.log(value);
    if (boolean) {
      value = value.eventName
    }
    const matches = value.match(/^[^\s]+(\s+[^\s]+)*$/);
    // tslint:disable-next-line: object-literal-key-quotes
    return matches ? null : { error: 'Should not begin or end with space.' };
  } else {
    return null;
  }
}



export const tickerExchangeMatch = (ticker, exchange, old_ticker, old_exchange): ValidatorFn => {
  return (form: UntypedFormGroup): any => {
    if (form.get(ticker).value && form.get(exchange).value && form.get(old_ticker).value && form.get(old_exchange).value) {
      if ((form.get(ticker).value.toUpperCase() == form.get(old_ticker).value.toUpperCase()) && (form.get(exchange).value.toUpperCase() == form.get(old_exchange).value.toUpperCase())) {
        form.get(ticker).setErrors({ error: 'Above Ticker and exchange should not be same.' })
        return;
      } else {
        form.get(ticker).setErrors(null);
        return;
      }
    }
  };
}

const findDuplicate = (arr: any,key1: string,key2: string) => {
  var _unArray = [];
  var _duplicateArray = [];
  arr.forEach(function(item) {
      var isPresent = _unArray.filter(function(elem) {
        if(key1 && key2 && elem[key1] && item[key1] && elem[key2] && item[key2])
          return elem[key1].toString().toUpperCase() === item[key1].toString().toUpperCase() && elem[key2].toString().toUpperCase() === item[key2].toString().toUpperCase()
      })
      if (isPresent.length == 0) {
          _unArray.push(item)
      } else {
          _duplicateArray.push(item)
      }
  })

  if(_duplicateArray.length) return {isInValid: true};
  return {isInValid: false }
}
const checkPrimaryTickerCount = (array: any) => {
  let primaryTickerCount = 0;
  array.forEach(function(ticker: any) { 
    if (ticker['primary_ticker']) primaryTickerCount += 1
  })

  if (primaryTickerCount >= 2) return true
  else return false;

}

export const numbersAndDecimalsOnly = function (control: AbstractControl): ValidationErrors | null {
  const regex = /^\d+(?:\.\d{1,4})?$/;
  // tslint:disable-next-line: prefer-const
  let value: string = control.value || '';

  if (value) {
    return (!regex.test(value)) ? { error: 'Invalid. It should have only numbers or decimals (for decimal upto 4 values allow)' } : null;
  } else {
    return null;
  }
}

// alphanumeric upto 12 only
export const alphanumericUptoTwelveOnly = function (control: AbstractControl): ValidationErrors | null {
  const regex = /^[a-zA-Z0-9]{1,12}$/;  // alphanumeric exact 12 letters
  // tslint:disable-next-line: prefer-const
  let value: string = control.value || '';
  if (value) {
    return (!regex.test(value)) ? { error: 'Invalid. It should have up to 12 alphanumerics' } : null;
  } else {
    return null;
  }
}


// alphanumeric upto 9 only
export const alphanumericUptoNineOnly = function (control: AbstractControl): ValidationErrors | null {
  const regex = /^[a-zA-Z0-9]{1,9}$/;  
  // tslint:disable-next-line: prefer-const
  let value: string = control.value || '';
  if (value) {
    return (!regex.test(value)) ? { error: 'Invalid. It should have up to 9 alphanumerics' } : null;
  } else {
    return null;
  }
}


// alphanumeric upto 7 only
export const alphanumericUptoSevenOnly = function (control: AbstractControl): ValidationErrors | null {
  const regex = /^[a-zA-Z0-9]{1,7}$/;
  // tslint:disable-next-line: prefer-const
  let value: string = control.value || '';
  if (value) {
    return (!regex.test(value)) ? { error: 'Invalid. It should have up to 7 alphanumerics' } : null;
  } else {
    return null;
  }
}

// digits upto 10 only
export const digitsUptoTenOnly = function (control: AbstractControl): ValidationErrors | null {
  const regex = /^[0-9]{1,10}$/;  
  // tslint:disable-next-line: prefer-const
  let value: string = control.value || '';
  if (value) {
    return (!regex.test(value)) ? { error: 'Invalid. It should have up to 10 digits' } : null;
  } else {
    return null;
  }
}
export const phoneNumberWithCountryCode = function (control: AbstractControl): ValidationErrors | null {
  //const regex = /^\+[1-9]{1,3}-\d{1,17}/;
  const regex = /^\+\d{1,3}\-\d{1,17}$/;
  // tslint:disable-next-line: prefer-const
  let value: string = control.value || '';

  if (value) {
    return (!regex.test(value)) ? { error: 'Invalid phone number.' } : null;
  } else {
    return null;
  }
};

export const countryValid = function (control: AbstractControl): ValidationErrors | null {
  let value: string = control.value || '';
  let countryname =[]
  countries.map(name => {
    countryname.push(name.name); 
  });
  if (value) {
    return (!countryname.includes(value)) ? { error: 'Invalid Country.' } : null;
  } else {
    return null;
  }
};


export const stateValid = function (control: AbstractControl): ValidationErrors | null {
  let value: string = control.value || '';
  let statename =[]
  states.map(name => {
    statename.push(name.name); 
  });
  if (value) {
    return (!statename.includes(value)) ? { error: 'Invalid State.' } : null;
  } else {
    return null;
  }
};

export const cityValid = function (control: AbstractControl): ValidationErrors | null {
  let value: string = control.value || '';
  let cityname =[]
  cities.map(name => {
    cityname.push(name.name); 
  });
  if (value) {
    return (!cityname.includes(value)) ? { error: 'Invalid City.' } : null;
  } else {
    return null;
  }
}

export const time_zone = function (control: AbstractControl): ValidationErrors | null {
  let value: string = control.value || '';
  if (value) {
    return (!timeZoneList.includes(value)) ? { error: 'Invalid time zone.' } : null;
  } else {
    return null;
  }
};

